// DIsplay Comment Form as a Modal.

jQuery(document).ready(function ($) {
    $(".single-member").on("mouseover", function () {
        // Remove 'blur' class from all elements
        $(".single-member").find("img").addClass("blur");
        // Add 'blur' class to the hovered element
        $(this).find("img").removeClass("blur");
    });
    $(".single-member").on("mouseleave", function () {
        // Remove 'blur' class from all elements
        $(".single-member").find("img").removeClass("blur");
        // Add 'blur' class to the hovered element
        $(this).find("img").removeClass("blur");
    });
});
